<template>
	<v-list-item>
		<v-list-item-avatar color="accent" v-if="user">
			<v-img  v-if="user.profile_image" :src="user.profile_image"></v-img>
			<v-icon color="white" v-else>mdi-account</v-icon>
		</v-list-item-avatar>
		<v-list-item-content>
			<v-list-item-title>{{note.content}}</v-list-item-title>
			<v-list-item-subtitle>
				{{user.display_name}} - 
				<DateNote :date="note.created" format="DD/MM/yy HH:mm"></DateNote>
			</v-list-item-subtitle>
		</v-list-item-content>
		<v-list-item-action>
			<TogglePinned :item="note" :id="id" :collection="collection" subkey="notes" :subid="note.id"></TogglePinned>
		</v-list-item-action>
	</v-list-item>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import DateNote from "@/components/elements/DateNote"
	import TogglePinned from "@/components/elements/TogglePinned"
	export default {
		name: "Note", 
		props: {
			collection: {type: String},
			id: {type: String },
			note: {type: Object}
		},
		data: () => {
			return {

			}
		},
		components: {
			DateNote, 
			TogglePinned	
		},
		computed: {
			...Vuex.mapState({
				users: state => state.users,
				user(state){
					var user = state.user;
					if( user.id == this.note.author ){
						return user;
					}
					else{
						return this.users.find( u => u.id == this.note.author )
					}
				}
			}),
		},
		methods: {
		}
		// created(){
			
		// }

	}
</script>